package horcrux.common.utils

class DefaultMap<K, V>(
    private val map: Map<K, V>,
    private val defaultValueProvider: (K) -> V
) : Map<K, V> by map {
    override fun get(key: K): V = map[key] ?: defaultValueProvider(key)
}

fun <K, V> defaultMapOf(vararg pairs: Pair<K, V>, defaultValueProvider: (K) -> V) =
    DefaultMap(mapOf(*pairs), defaultValueProvider)
